import { gql } from "apollo-boost"

export const GET_ACCOUNT_IMPLEMENTER_BY_UID = gql`
  query getAccountImplementerByUid($uid: String!) {
    ImplementerByUid(uid: $uid) {
      id
      name
    }
  }
`
